import { useCallback, useEffect, useRef, useState } from 'react';

const CONFETTI_DURATION_MS = 4000;
const STAR_TICK_MS = 200;

export function useStarRewards({ videoId }) {
  const [starCount, setStarCount] = useState(0);
  const [totalStarCount, setTotalStarCount] = useState(0);
  const [displayedStarCount, setDisplayedStarCount] = useState(0);
  const [showConfetti, setShowConfetti] = useState(false);
  const audioRef = useRef(null);

  // Reset on video change.
  useEffect(() => {
    setStarCount(0);
    setTotalStarCount(0);
    setDisplayedStarCount(0);
  }, [videoId]);

  // Animate displayed count toward total.
  useEffect(() => {
    if (totalStarCount === displayedStarCount) return undefined;
    const increment = totalStarCount > displayedStarCount ? 1 : -1;
    const timer = setTimeout(
      () => setDisplayedStarCount((prev) => prev + increment),
      STAR_TICK_MS,
    );
    return () => clearTimeout(timer);
  }, [totalStarCount, displayedStarCount]);

  // Play tada + auto-dismiss confetti.
  useEffect(() => {
    if (!showConfetti) return undefined;
    const audio = new Audio('/sound/tada.wav');
    audioRef.current = audio;
    audio.play().catch((error) => {
      console.error('Audio playback failed:', error);
    });
    const timer = setTimeout(() => {
      setShowConfetti(false);
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    }, CONFETTI_DURATION_MS);
    return () => clearTimeout(timer);
  }, [showConfetti]);

  const claimStars = useCallback(() => {
    setTotalStarCount((prev) => prev + starCount);
    setStarCount(0);
  }, [starCount]);

  return {
    starCount,
    setStarCount,
    totalStarCount,
    setTotalStarCount,
    displayedStarCount,
    showConfetti,
    setShowConfetti,
    claimStars,
  };
}
